import { Injectable } from '@angular/core';
import * as fileSaver from 'file-saver';

@Injectable()

// este servicio se usa en todos los casos en que se requiera guardar un archivo desde el back
// mas que nada para centralizar el código y evitar errores si hay cambios

export class FileSaverService {

  SaveToFileSystem(response) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    let filename = parts[1].split('=')[1];
    filename = filename.replace(/['"]+/g, '');
    filename = decodeURIComponent(filename).replace(/\+/g,' ');
    const blob = new Blob([response._body]);
    fileSaver.saveAs(blob, filename);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/file-saver-service.ts